import React from 'react'
import styled from 'styled-components'

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`

const Icon = styled.div`
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #2c271c;
  top: 2px;
  left: 2px;
  position: absolute;
  transition: opacity 150ms;
  }
`
// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: ${props => props.disabled ? "solid 1px #D6D6D6;" : "solid 1px #807d77;"};
  position: relative;
  transition: all 150ms;

  ${HiddenCheckbox}:focus + & {
  }

  ${Icon} {
    opacity: ${props => (props.checked ? 1 : 0)}
  }
`

const Checkbox = ({ className, checked, disabled, ...props }) => {
  return (
  <CheckboxContainer className={className}>
    <HiddenCheckbox checked={checked} {...props} />
    <StyledCheckbox checked={checked} disabled={disabled}>
      <Icon className="filter-checkbox-icon" />
    </StyledCheckbox>
  </CheckboxContainer>
)}

export default Checkbox
